import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import AdditionalDetailsPreviewMapper from "../../../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import TransactionOccurrenceDetails from "../../../../_utils/TransactionCommonComponents/TransactionOccurrenceDetails";

const ScheduleTransactionStepConfirm = (props) => {
  const formateDate = (date) => {
    const dates = new Date(date || new Date());

    const day = dates.toLocaleDateString("en-GB", { day: "2-digit" });
    const month = dates.toLocaleDateString("en-GB", { month: "short" });
    const year = dates.toLocaleDateString("en-GB", { year: "numeric" });

    return `${day} ${month}, ${year}`;
  };

  return (
    <>
      <div className="w-width-full Qlg:px-padding-base px-padding-md  Qsmd:py-padding-lg py-padding-md max-w-tab-width-normal mx-auto">
        <CommonLayout>
          <SourceDestinationAccountDetail
            type="source"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />

          <SourceDestinationAccountDetail
            type="destination"
            flow="beneficiary"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />

          <div className="w-width-full flex flex-col gap-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={props?.txnPayLoad}
            />

            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={props?.txnPayLoad?.settleType}
            />
          </div>
          <div className="w-width-full flex flex-col gap-gap-md">
            <NameFieldCard
              title={globalText?.SCHEDULE_NAME}
              value={props?.txnPayLoad?.scheduleName}
              previewMode={true}
            />

            <ConfidentialCard
              icon={ICONS?.CONFIDENTIAL_TRANSACTION}
              title={globalText?.CREATE_AS_CONFIDENTIAL}
              note={globalText?.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
              toggleState={props?.isConfidential}
              isPreview={true}
            />
          </div>
          <CategorySelector
            previewMode={true}
            selectedCategory={props?.txnPayLoad?.selectedCategory}
            category={props?.txnPayLoad?.mergeCategory || []}
            IFSC={props?.txnPayLoad?.bankAccountIFSC}
            accountNumber={props?.txnPayLoad?.bankAccountNo}
            beneAccountId={props?.txnPayLoad?.beneAccountId}
            unassignCategories={[]}
            unassignlength={[]}
          />
          <TransactionOccurrenceDetails
            previewMode={true}
            txnPayLoad={props.txnPayLoad}
            formatDate={formateDate}
          />
          <AdditionalDetailsPreviewMapper
            mappingData={props.txnPayLoad.mergeCategory}
            previewImages={props?.previewImages}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default ScheduleTransactionStepConfirm;
